import type { StationChainWriteRequest } from '@/api/generated/schemas';
import type { StationChainFormValues } from './stationChainFormSchema';

function emptyToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Mapuje hodnoty formuláře na API tělo zápisu trasy. Pořadí `stops` je významné — BE z indexu
 * odvodí `Order` a přepočítá délku/dobu i směr (`IsReturn`).
 */
export function toStationChainRequestBody(
  values: StationChainFormValues
): StationChainWriteRequest {
  return {
    name: values.name.trim(),
    code: emptyToNull(values.code),
    color: values.color,
    status: values.status,
    stops: values.stops.map((stop) => ({
      id: stop.id,
      stationId: stop.stationId,
      stationDetailId: stop.stationDetailId,
      dwell: stop.dwell,
      travel: stop.travel,
      travelAuto: stop.travelAuto,
    })),
  } satisfies StationChainWriteRequest;
}
